export default "__VITE_ASSET__COXmaMXT__"